<template>
    <Autocomplete
        :fetch-keys="() => axios.get('/task/query/all/field').then(e => e.data.map(e => [e.value, e.key]))"
        :fetch-options="getList"
        :label="type == 'draft' ? 'taskName' : 'keyTask'"
        v-bind="$attrs"
        @select="toDetail"
    />
</template>

<script setup>
import { useRouter } from 'vue-router';
import axios from '@/plugins/axios';

const emit = defineEmits(['select']);

const props = defineProps({
    type: String,
    lookStatus: Number,
    params: Object
});

const router = useRouter();

const url = () => {
    if (props.type === 'pending') {
        return '/pending/task/page';
    }
    if (props.type === 'draft') {
        return '/start/task/draft/query';
    }
    if (props.type === 'detail') {
        return '/forms/query/detail';
    } else {
        return '/look/task/page';
    }
};

function getList(keyword, keys) {
    const config = {};
    if (url().includes('/forms/query/detail')) {
        config.newGrayAjax = {
            baseURL: '/hundred-gcp',
            url: '/task/query/page',
            method: 'post',
            data: {
                lookStatus: props.lookStatus,
                ...props.params,
                pageNum: 1,
                pageSize: 50,
                keyword,
                keys,
                fieldType: keys.length > 0 ? 1 : 0
            }
        };
    }
    return axios({
        url: url(),
        method: 'post',
        ...config,
        data: {
            lookStatus: props.lookStatus,
            ...props.params,
            pageNum: 1,
            pageSize: 50,
            keyword,
            keys,
            fieldType: keys.length > 0 ? 1 : 0
        }
    })
        .then(e => e.data?.records || []);
}

function toDetail(row) {
    if (props.type === 'draft') {
        emit('select', row);
    } else {
        router.push(`/task/waitDeal/${row.id}`);
        emit('select', row);
    }
    vis.value = false;
}
</script>
